// @flow

import './index.scss';
import * as React from 'react';
import { useTranslate } from '@insolus/react-i18n';
import { Button } from '@insolus/ui-kit';

type Props = {|
    onClick: () => any
|};

const AdBookmarkDefaultButton = ({ onClick }: Props): React.Node => {
    const { __ } = useTranslate();

    return (
        <Button
            type="default"
            className="AdBookmarkDefaultButton"
            onClick={onClick}
            title={__('add-to-bookmarks')}
            aria-label={__('add-to-bookmarks')}
        >
            <img src="img/star.svg" alt={__('add-to-bookmarks')} />
        </Button>
    );
};

export default AdBookmarkDefaultButton;
